import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableSort = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4 16L8 12H5V0H3V12H0L4 16ZM9 4H18V6H9V4ZM9 8H16V10H9V8ZM9 0H20V2H9V0ZM9 12H14V14H9V12Z",
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgTableSort);
export { ForwardRef as ReactComponent };
